import { toast } from 'react-toastify';
import { applicantConstants } from '../constants';
import { applicantProfileService } from '../services';
import { jobProfileActions } from '../actions';

const createApplicant = (createData) => {
  const request = (applicant) => {
    return { type: applicantConstants.CREATE_REQUEST, applicant };
  };
  const success = (applicant) => {
    return { type: applicantConstants.CREATE_SUCCESS, applicant };
  };
  const failure = (error) => {
    return { type: applicantConstants.CREATE_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(createData));
    return applicantProfileService.createApplicant(createData).then(
      (applicant) => {
        // toast.success("Applicant created");
        dispatch(success(applicant));
        return applicant;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
      }
    );
  };
};

const candidateReferral = (createData) => {
  const request = (applicant) => {
    return { type: applicantConstants.CANDIDATE_REFERRAL_REQUEST, applicant };
  };
  const success = (applicant) => {
    return { type: applicantConstants.CANDIDATE_REFERRAL_SUCCESS, applicant };
  };
  const failure = (error) => {
    return { type: applicantConstants.CANDIDATE_REFERRAL_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(createData));
    return applicantProfileService.candidateReferral(createData).then(
      (applicant) => {
        // toast.success("Applicant created");
        dispatch(success(applicant));
        return applicant;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
      }
    );
  };
};

const createExternalApplicant = (createData) => {
  const request = (applicant) => {
    return { type: applicantConstants.CREATEEXTERNAL_REQUEST, applicant };
  };
  const success = (applicant) => {
    return { type: applicantConstants.CREATEEXTERNAL_SUCCESS, applicant };
  };
  const failure = (error) => {
    return { type: applicantConstants.CREATEEXTERNAL_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(createData));
    return applicantProfileService.createExternalApplicant(createData).then(
      (applicant) => {
        // toast.success("Create profile successfully");
        dispatch(success(applicant));
        return applicant;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
        return error;
      }
    );
  };
};

const updateApplicant = (updateData, id) => {
  const request = (applicant) => {
    return { type: applicantConstants.UPDATE_REQUEST, applicant };
  };
  const success = (applicant) => {
    return { type: applicantConstants.UPDATE_SUCCESS, applicant };
  };
  const failure = (error) => {
    return { type: applicantConstants.UPDATE_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(updateData));
    return applicantProfileService.updateApplicant(updateData, id).then(
      (applicant) => {
        // toast.success("Applicant updated");
        dispatch(success(applicant));
        return applicant;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
        return false;
      }
    );
  };
};

const deleteApplicant = (id) => {
  const request = (id) => {
    return { type: applicantConstants.DELETE_REQUEST, id };
  };
  const success = (id) => {
    return { type: applicantConstants.DELETE_SUCCESS, id };
  };
  const failure = (id, error) => {
    return { type: applicantConstants.DELETE_FAILURE, id, error };
  };

  return (dispatch) => {
    dispatch(request(id));

    return applicantProfileService.deleteApplicant(id).then(
      (res) => {
        // toast.success("Applicant deleted");
        dispatch(success(id));
        return true;
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(id, error.toString()));
        return false;
      }
    );
  };
};

const getApplicant = (id) => {
  const request = (id) => {
    return { type: applicantConstants.GETALL_REQUEST, id };
  };
  const success = (boardApplicant) => {
    return { type: applicantConstants.GETALL_SUCCESS, boardApplicant };
  };
  const failure = (id, error) => {
    return { type: applicantConstants.GETALL_FAILURE, id, error };
  };

  return (dispatch) => {
    dispatch(request(id));

    return applicantProfileService.getApplicant(id).then(
      (res) => {
        if (res?.results && res?.results.length === 1) {
          dispatch(success(res?.results[0]));
          return res?.results[0];
        }
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(id, error.toString()));
        return false;
      }
    );
  };
};

const getHistory = (id) => {
  const request = (history) => {
    return { type: applicantConstants.GETHISTORY_REQUEST, history };
  };
  const success = (history) => {
    return { type: applicantConstants.GETHISTORY_SUCCESS, history };
  };
  const failure = (error) => {
    return { type: applicantConstants.GETHISTORY_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    applicantProfileService.applicanHistoryGet(id).then((history, error) => {
      if (history) {
        dispatch(success(history));
      } else {
        dispatch(failure(error.toString()));
      }
    });
  };
};

const getComment = (id) => {
  const request = (comment) => {
    return { type: applicantConstants.GETCOMMENT_REQUEST, comment };
  };
  const success = (comment) => {
    return { type: applicantConstants.GETCOMMENT_SUCCESS, comment };
  };
  const failure = (error) => {
    return { type: applicantConstants.GETCOMMENT_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    applicantProfileService.applicanCommentGet(id).then((comment, error) => {
      if (comment) {
        dispatch(success(comment));
      } else {
        dispatch(failure(error.toString()));
      }
    });
  };
};

const announcementCommentGet = (id) => {
  const request = (comment) => {
    return { type: applicantConstants.GETCOMMENT_REQUEST, comment };
  };
  const success = (comment) => {
    return { type: applicantConstants.GETCOMMENT_SUCCESS, comment };
  };
  const failure = (error) => {
    return { type: applicantConstants.GETCOMMENT_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    applicantProfileService
      .announcementCommentGet(id)
      .then((comment, error) => {
        if (comment) {
          dispatch(success(comment?.data));
        } else {
          dispatch(failure(error.toString()));
        }
      });
  };
};

const createComment = (createData, req) => {
  const request = (comment) => {
    return { type: applicantConstants.CREATECOMMENT_REQUEST, comment };
  };
  const success = (comment) => {
    return { type: applicantConstants.CREATECOMMENT_SUCCESS, comment };
  };
  const failure = (error) => {
    return { type: applicantConstants.CREATECOMMENT_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    applicantProfileService.createComment(createData).then((comment, error) => {
      if (comment) {
        // toast.success("Comment Added");
        dispatch(success(comment));
        dispatch(getComment(req.selectedId))
      } else {
        dispatch(failure(error.toString()));
      }
    });
  };
};

const announcementCreateComment = (createData) => {
  const request = (comment) => {
    return { type: applicantConstants.CREATECOMMENT_REQUEST, comment };
  };
  const success = (comment) => {
    return { type: applicantConstants.CREATECOMMENT_SUCCESS, comment };
  };
  const failure = (error) => {
    return { type: applicantConstants.CREATECOMMENT_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    applicantProfileService
      .announcementCreateComment(createData)
      .then((comment, error) => {
        if (comment) {
          // toast.success("Comment Added");
          dispatch(success(comment));
        } else {
          dispatch(failure(error.toString()));
        }
      });
  };
};

const editComment = (updateData, id) => {
  const request = (comment) => {
    return { type: applicantConstants.UPDATECOMMENT_REQUEST, comment };
  };
  const success = (comment) => {
    return { type: applicantConstants.UPDATECOMMENT_SUCCESS, comment };
  };
  const failure = (error) => {
    return { type: applicantConstants.UPDATECOMMENT_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    return applicantProfileService
      .editComment(updateData, id)
      .then((comment, error) => {
        if (comment) {
          // toast.success("Comment updated");
          dispatch(success(comment));
          return comment;
        } else {
          dispatch(failure(error.toString()));
        }
      });
  };
};

const deleteComment = (id) => {
  const request = (id) => {
    return { type: applicantConstants.DELETECOMMENT_REQUEST, id };
  };
  const success = (id) => {
    return { type: applicantConstants.DELETECOMMENT_SUCCESS, id };
  };
  const failure = (id, error) => {
    return { type: applicantConstants.DELETECOMMENT_FAILURE, id, error };
  };

  return (dispatch) => {
    dispatch(request(id));

    applicantProfileService.deleteComment(id).then(
      (res) => {
        // toast.success("Comment deleted");
        dispatch(success(id));
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(id, error.toString()));
      }
    );
  };
};

const updateCommentAccess = (req) => {
  const id = {
    id: req.id,
    isPrivate: req.isPrivate
  }
  const request = (id) => {
    return { type: applicantConstants.UPDATECOMMENTACCESS_REQUEST, id };
  };
  const success = (id) => {
    return { type: applicantConstants.UPDATECOMMENTACCESS_SUCCESS, id };
  };
  const failure = (id, error) => {
    return { type: applicantConstants.UPDATECOMMENTACCESS_FAILURE, id, error };
  };

  return (dispatch) => {
    dispatch(request(id));

    applicantProfileService.updateCommentAccess(id).then(
      (res) => {
        dispatch(success(id));
        dispatch(getComment(req.selectedId))
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(id, error.toString()));
      }
    );
  };
};

const moveDynamicReferral = (req) => {
  const id = {
    id: req.id,
    jobId: req.jobId
  }
  const request = (id) => {
    return { type: applicantConstants.DYNAMIC_REFERRAL_REQUEST, id };
  };
  const success = (id) => {
    return { type: applicantConstants.DYNAMIC_REFERRAL_SUCCESS, id };
  };
  const failure = (id, error) => {
    return { type: applicantConstants.DYNAMIC_REFERRAL_FAILURE, id, error };
  };

  return (dispatch) => {
    dispatch(request(id));

    applicantProfileService.moveDynamicReferral(id).then(
      (res) => {
        dispatch(success(id));
        dispatch(jobProfileActions.getAllReferral());
        toast.success(res.message);
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(id, error.toString()));
      }
    );
  };
};

const cloneJobProfile = (req) => {
  const id = {
    id: req.id,
    jobId: req.jobId
  }
  const request = (id) => {
    return { type: applicantConstants.CLONE_JOB_REQUEST, id };
  };
  const success = (id) => {
    return { type: applicantConstants.CLONE_JOB_SUCCESS, id };
  };
  const failure = (id, error) => {
    return { type: applicantConstants.CLONE_JOB_FAILURE, id, error };
  };

  return (dispatch) => {
    dispatch(request(id));

    return new Promise((resolve, reject) => {
      applicantProfileService.cloneJobProfile(id)
        .then(
          (res) => {
            dispatch(success(id));
            toast.success(res.message);
            resolve(res);
          },
          (error) => {
            toast.error(error.toString());
            dispatch(failure(id, error.toString()));
            reject(error);
          }
        );
    });
  };
};

const getProfileSummary = () => {
  const request = (profileSummary) => {
    return { type: applicantConstants.GETSUMMARY_REQUEST, profileSummary };
  };
  const success = (profileSummary) => {
    return { type: applicantConstants.GETSUMMARY_SUCCESS, profileSummary };
  };
  const failure = (error) => {
    return { type: applicantConstants.GETSUMMARY_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    return applicantProfileService
      .getProfileSummary()
      .then((profileSummary, error) => {
        if (profileSummary) {
          dispatch(success(profileSummary));
          return profileSummary;
        } else {
          dispatch(failure(error.toString()));
          return error;
        }
      });
  };
};

const getChartSummary = (query) => {
  const request = (chartSummary) => {
    return { type: applicantConstants.GETCHARTSUMMARY_REQUEST, chartSummary };
  };
  const success = (chartSummary) => {
    return { type: applicantConstants.GETCHARTSUMMARY_SUCCESS, chartSummary };
  };
  const failure = (error) => {
    return { type: applicantConstants.GETCHARTSUMMARY_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    applicantProfileService
      .getChartSummary(query)
      .then((chartSummary, error) => {
        if (chartSummary) {
          dispatch(success(chartSummary));
        } else {
          dispatch(failure(error.toString()));
        }
      });
  };
};

//Externalform
const getExternalData = (id) => {
  const request = (externalData) => {
    return { type: applicantConstants.GETEXTERNALDATA_REQUEST, externalData };
  };
  const success = (externalData) => {
    return { type: applicantConstants.GETEXTERNALDATA_SUCCESS, externalData };
  };
  const failure = (error) => {
    return { type: applicantConstants.GETEXTERNALDATA_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request(id));

    applicantProfileService.getExternalData(id).then(
      (externalData) => {
        dispatch(success(externalData));
      },
      (error) => {
        toast.error(error.toString());
        dispatch(failure(error.toString()));
      }
    );
  };
};

//Board Data
const getBoardData = (query) => {
  const request = (board) => {
    return { type: applicantConstants.GETBOARDDATA_REQUEST, board };
  };
  const success = (board) => {
    return { type: applicantConstants.GETBOARDDATA_SUCCESS, board };
  };
  const failure = (error) => {
    return { type: applicantConstants.GETBOARDDATA_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    return applicantProfileService.getKanbanData(query).then((data, error) => {
      if (data?.board) {
        data.board.jobStatus = data?.jobStatus;
        dispatch(success(data?.board));
        return data?.board;
      } else {
        dispatch(failure(error.toString()));
        return error;
      }
    });
  };
};

const updateStatus = (updateData, jobId) => {
  const request = (data) => {
    return { type: applicantConstants.UPDATESTATUS_REQUEST, data };
  };
  const success = (data) => {
    return { type: applicantConstants.UPDATESTATUS_SUCCESS, data };
  };
  const failure = (error) => {
    return { type: applicantConstants.UPDATESTATUS_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    return applicantProfileService
      .updateKanbanStatus(updateData, jobId)
      .then((data, error) => {
        if (data) {
          dispatch(success(data));
          return data;
        } else {
          dispatch(failure(error.toString()));
          return false;
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
};

const getApplicantStatus = (jobId) => {
  const request = (applicantStatus) => {
    return { type: applicantConstants.GETSTATUSDATA_REQUEST, applicantStatus };
  };
  const success = (applicantStatus) => {
    return { type: applicantConstants.GETSTATUSDATA_SUCCESS, applicantStatus };
  };
  const failure = (error) => {
    return { type: applicantConstants.GETSTATUSDATA_FAILURE, error };
  };

  return (dispatch) => {
    dispatch(request());

    return applicantProfileService
      .getApplicantStatus(jobId)
      .then((data, error) => {
        if (data) {
          dispatch(success(data));
          return data?.board;
        } else {
          dispatch(failure(error?.toString()));
          return error;
        }
      });
  };
};

export const ApplicantActions = {
  createApplicant,
  updateApplicant,
  deleteApplicant,
  getHistory,
  getComment,
  createComment,
  editComment,
  getProfileSummary,
  getChartSummary,
  deleteComment,
  getExternalData,
  createExternalApplicant,
  getBoardData,
  updateStatus,
  getApplicantStatus,
  getApplicant,
  announcementCreateComment,
  announcementCommentGet,
  updateCommentAccess,
  candidateReferral,
  moveDynamicReferral,
  cloneJobProfile
};
